<template>
    <div class="d-flex">
        <div class="sidebar-column">
            <slot name="sidebar"/>
        </div>
        <div class="main-column">
            <slot name="main"/>
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({}),
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>
    .sidebar-column{
        min-width: 250px;
        max-width: 250px;
        height: calc(100vh - 60px - 12px);
    }
    .sidebar-column-collapsed{
        min-width: 150px;
        max-width: 150px;
    }
    .main-column{
        width: 100%;
        height: 100%;
    }
</style>